import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"
import Icon from "@irati/ui/src/Icon"
import padding from "@irati/ui/src/global/padding"

export const TickImage = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`

export const PerksGOImage = styled(Icon)`
  width: 80px;
  height: 52px;
  display: block;
  margin: ${({theme}) => `${theme.spacing.two} auto`};
`

export const PerksGOBackground = styled.div`
  ${({theme}) => `background: ${theme.colors.greys.lightest};`}
  margin: 30px -${padding.small};

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    margin-left: -${padding.large};
    margin-right: -${padding.large};
  `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    margin-left: -${padding.base};
    margin-right: -${padding.base};
  `}
`

export const PerksGOWrapper = styled(Flex)`
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    padding: ${padding.base};
  `}
`
